<template>
  <div class="content-item">
    <div class="row mt-2">
      <div class="col-12 text-center">
        <h3>勞工健康指導紀錄表</h3>
      </div>
      <div class="col-12 text-right service-date">
        <p>諮詢日期：{{ getCreateDate }}</p>
      </div>
      <div class="col-12 outline-border p-0">
        <div class="outline-bottom">
          <div class="row p-0">
            <div class="col-2 title">
              <p>單位</p>
            </div>
            <div class="col-2 border-left">
              <p>{{ formData.unit.answer }}</p>
            </div>
            <div class="col-1 border-left">
              <p>員編</p>
            </div>
            <div class="col-2 border-left">
              <p>{{ selectedPatient.givenId }}</p>
            </div>
            <div class="col-1 border-left">
              <p>姓名</p>
            </div>
            <div class="col-3 border-left">
              <p>{{ selectedPatient.name }}</p>
            </div>
          </div>
        </div>
        <div class="outline-bottom">
          <div class="row p-0">
            <div class="col-2 title">
              <p>年齡</p>
            </div>
            <div class="col-2 border-left">
              <p>{{ selectedPatient.age }}歲</p>
            </div>
            <div class="col-1"></div>
            <div class="col-2"></div>
            <div class="col-1 border-left">
              <p>性別</p>
            </div>
            <div class="col-3 border-left">
              <p>{{ getGenderWording }}</p>
            </div>
          </div>
        </div>
        <div class="outline-bottom">
          <div class="row p-0">
            <div class="col-2 title">
              <p>在職年資</p>
            </div>
            <div class="col-2 border-left">
              <p>{{ formData.seniority.answer }}</p>
            </div>
            <div class="col-1"></div>
            <div class="col-2"></div>
            <div class="col-1"></div>
            <div class="col-3"></div>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-2 title">
              <p>作業型態</p>
            </div>
            <div class="col-2 border-left">
              <div class="row p-0">
                <div class="col-12 border-bottom">
                  <p class="p-0">作業場所與內容:</p>
                </div>
                <div class="col-12">
                  <p class="p-0">工作型態與時間:</p>
                </div>
              </div>
            </div>
            <div class="col-10 border-left operator-content">
              <div class="row p-0" style="padding-right: 15px !important;">
                <div class="col-12 border-bottom">
                  <p class="p-0">
                    <span v-if="formData.operatorType.answer==='O1'">■ </span>
                    <span v-else>□ </span>
                    行政人員
                    <span v-if="formData.operatorType.answer==='O2'">■ </span>
                    <span v-else>□ </span>
                    現場操作人員
                    <span v-if="formData.operatorType.answer==='other'">■ </span>
                    <span v-else>□ </span>
                    其他: <span v-if="formData.operatorType.answer!=='other'">______ </span>
                    <span v-else>{{formData.operatorTypeNote.answer}}</span>
                  </p>
                </div>
                <div class="col-12">
                  <p class="p-0">{{formData.workTypeAndTime.answer}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-1 title">
              <p>生活習慣調查</p>
            </div>
            <div class="col-4 border-left">
              <div class="row p-0">
                <div class="col-12">
                  <p class="p-0">抽菸:
                    <span v-if="formData.smoke.answer==='no' || !formData.smoke.answer">■ </span>
                    <span v-else>□ </span>
                    無
                    <span v-if="formData.smoke.answer==='yes'">■ </span>
                    <span v-else>□ </span>
                    有
                    <span v-if="formData.smoke.answer==='yes'">(一天 {{ formData.smokeNote.answer }} 隻)</span>
                  </p>
                </div>
                <div class="col-12">
                  <p class="p-0">檳榔:
                    <span v-if="formData.betelNuts.answer==='no' || !formData.betelNuts.answer">■ </span>
                    <span v-else>□ </span>
                    無
                    <span v-if="formData.betelNuts.answer==='yes'">■ </span>
                    <span v-else>□ </span>
                    有
                    <span v-if="formData.betelNuts.answer==='yes'">(頻率 {{ formData.betelNutsNote.answer }} )</span>
                  </p>
                </div>
                <div class="col-12">
                  <p class="p-0">飲酒: <span v-if="formData.drinking.answer==='no' || !formData.drinking.answer">■ </span>
                    <span v-else>□ </span>
                    無
                    <span v-if="formData.drinking.answer==='yes'">■ </span>
                    <span v-else>□ </span>
                    有
                    <span v-if="formData.drinking.answer==='yes'">(頻率 {{ formData.drinkingNote.answer }} )</span></p>
                </div>
              </div>
            </div>
            <div class="col-4 border-left">
              <div class="row p-0">
                <div class="col-12">
                  <p class="p-0">睡眠型態:</p>
                  <p v-if="formData.sleepHour.answer.length===0">________ 小時/日</p>
                  <p v-else>{{formData.sleepHour.answer}} 小時/日</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-3 h-work-title">
              <p class="center-title">特別危害健康作業</p>
            </div>
            <template v-if="formData.hasSpecialHazardousWork.answer==='yes'">
              <div class="col-3 border-left">
                <div class="row p-0">
                  <div class="col-12" :class="{'border-bottom': formData.specialHazardousWork2.answer!==''}" v-if="formData.specialHazardousWork1.answer!==''">
                    <p>特檢名稱: {{ getSpecialHazardousWorkWording1 }}</p>
                  </div>
                  <div class="col-12" :class="{'border-bottom': formData.specialHazardousWork3.answer!==''}" v-if="formData.specialHazardousWork2.answer!==''">
                    <p>特檢名稱: {{ getSpecialHazardousWorkWording2 }} </p>
                  </div>
                  <div class="col-12" :class="{'border-bottom': formData.specialHazardousWork4.answer!==''}" v-if="formData.specialHazardousWork3.answer!==''">
                    <p>特檢名稱: {{ getSpecialHazardousWorkWording3 }}</p>
                  </div>
                  <div class="col-12" :class="{'border-bottom': formData.specialHazardousWork5.answer!==''}" v-if="formData.specialHazardousWork4.answer!==''">
                    <p>特檢名稱:{{ getSpecialHazardousWorkWording4 }}</p>
                  </div>
                  <div class="col-12" v-if="formData.specialHazardousWork5.answer!==''">
                    <p>特檢名稱: {{ getSpecialHazardousWorkWording5 }}</p>
                  </div>
                </div>
              </div>
              <div class="col-6 border-left h-work-option">
                <div class="row p-0" style="padding-right: 15px !important;">
                  <div class="col-12" :class="{'border-bottom': formData.specialHazardousWork2.answer!==''}" v-if="formData.specialHazardousWork1.answer!==''">
                    <p>
                      <span v-if="formData.specialHazardousWork1Level.answer==='1'">■ </span>
                      <span v-else>□ </span>一級
                      <span v-if="formData.specialHazardousWork1Level.answer==='2'">■ </span>
                      <span v-else>□ </span>二級
                      <span v-if="formData.specialHazardousWork1Level.answer==='3'">■ </span>
                      <span v-else>□ </span>三級
                      <span v-if="formData.specialHazardousWork1Level.answer==='4'">■ </span>
                      <span v-else>□ </span>四級</p>
                  </div>
                  <div class="col-12" :class="{'border-bottom': formData.specialHazardousWork3.answer!==''}" v-if="formData.specialHazardousWork2.answer!==''">
                    <p>
                      <span v-if="formData.specialHazardousWork2Level.answer==='1'">■ </span>
                      <span v-else>□ </span>一級
                      <span v-if="formData.specialHazardousWork2Level.answer==='2'">■ </span>
                      <span v-else>□ </span>二級
                      <span v-if="formData.specialHazardousWork2Level.answer==='3'">■ </span>
                      <span v-else>□ </span>三級
                      <span v-if="formData.specialHazardousWork2Level.answer==='4'">■ </span>
                      <span v-else>□ </span>四級
                    </p>
                  </div>
                  <div class="col-12" :class="{'border-bottom': formData.specialHazardousWork4.answer!==''}" v-if="formData.specialHazardousWork3.answer!==''">
                    <p>
                      <span v-if="formData.specialHazardousWork3Level.answer==='1'">■ </span>
                      <span v-else>□ </span>一級
                      <span v-if="formData.specialHazardousWork3Level.answer==='2'">■ </span>
                      <span v-else>□ </span>二級
                      <span v-if="formData.specialHazardousWork3Level.answer==='3'">■ </span>
                      <span v-else>□ </span>三級
                      <span v-if="formData.specialHazardousWork3Level.answer==='4'">■ </span>
                      <span v-else>□ </span>四級
                    </p>
                  </div>
                  <div class="col-12" :class="{'border-bottom': formData.specialHazardousWork5.answer!==''}" v-if="formData.specialHazardousWork4.answer!==''">
                    <p>
                      <span v-if="formData.specialHazardousWork4Level.answer==='1'">■ </span>
                      <span v-else>□ </span>一級
                      <span v-if="formData.specialHazardousWork4Level.answer==='2'">■ </span>
                      <span v-else>□ </span>二級
                      <span v-if="formData.specialHazardousWork4Level.answer==='3'">■ </span>
                      <span v-else>□ </span>三級
                      <span v-if="formData.specialHazardousWork4Level.answer==='4'">■ </span>
                      <span v-else>□ </span>四級
                    </p>
                  </div>
                  <div class="col-12" v-if="formData.specialHazardousWork5.answer!==''">
                    <p>
                      <span v-if="formData.specialHazardousWork5Level.answer==='1'">■ </span>
                      <span v-else>□ </span>一級
                      <span v-if="formData.specialHazardousWork5Level.answer==='2'">■ </span>
                      <span v-else>□ </span>二級
                      <span v-if="formData.specialHazardousWork5Level.answer==='3'">■ </span>
                      <span v-else>□ </span>三級
                      <span v-if="formData.specialHazardousWork5Level.answer==='4'">■ </span>
                      <span v-else>□ </span>四級
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="col-4 border-left">
                <div class="row p-0">
                  <div class="col-12">
                    <p>無</p>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-3 h-work-title">
              <p class="center-title">疾病史</p>
            </div>
            <template v-if="!formData.personalPrivacy.answer">
              <div class="col-8 border-left">
                <p>個人病史：
                  <span v-if="formData.personalMedicalHistory.answer==='no'">■ </span>
                  <span v-else>□ </span>
                  無
                  <span v-if="formData.personalMedicalHistory.answer==='yes'">■ </span>
                  <span v-else>□ </span>
                  有
                  <span v-if="formData.personalMedicalHistory.answer==='yes'">: {{formData.personalMedicalHistoryNote.answer}}</span>
                  <span v-else>_______</span>
                </p>
                <p>家族病史：
                  <span v-if="formData.familyMedicalHistory.answer==='no'">■ </span>
                  <span v-else>□ </span>
                  無
                  <span v-if="formData.familyMedicalHistory.answer==='yes'">■ </span>
                  <span v-else>□ </span>
                  有
                  <span v-if="formData.familyMedicalHistory.answer==='yes'">: {{formData.familyMedicalHistoryNote.answer}}</span>
                  <span v-else>_______</span>
                </p>
                <p>是否用藥：
                  <span v-if="formData.isUseDrug.answer==='no'">■ </span>
                  <span v-else>□ </span>
                  無
                  <span v-if="formData.isUseDrug.answer==='yes'">■ </span>
                  <span v-else>□ </span>
                  有
                  <span v-if="formData.isUseDrug.answer==='yes'">: {{formData.isUseDrugNote.answer}}</span>
                  <span v-else>_______</span>
                </p>
              </div>
            </template>
            <template v-else>
              <div class="col-4 border-left">
                <div class="row p-0">
                  <div class="col-12">
                    <p>個人隱私,不願透露 </p>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0 justify-content-center">
            <div class="col-12">
              <p><span class="font-weight-bold mr-1">體健檢後分級管理</span>
                <span v-if="formData.healthcareManagement.answer==='yes'">■ </span>
                <span v-else>□ </span>
                本次執行
                <span v-if="formData.healthcareManagement.answer==='no'">■ </span>
                <span v-else>□ </span>
                本次沒執行
              </p>
            </div>
            <template v-if="formData.healthcareManagement.answer==='yes'">
              <div class="col-12">
                <p>(
                  <span class="ml-1" v-if="formData.healthcareExecute.answer.includes('new')">■ </span>
                  <span class="ml-1" v-else>□ </span>
                  <span class="font-weight-bold">新人</span>
                  <span class="ml-1" v-if="formData.healthcareExecute.answer.includes('specialHazardousWork')">■ </span>
                  <span class="ml-1" v-else>□ </span>
                  <span class="font-weight-bold">特別危害健康作業</span>
                  <span class="ml-1" v-if="formData.healthcareExecute.answer.includes('year')">■ </span>
                  <span class="ml-1" v-else>□ </span>
                  年度
                  <span class="ml-1" v-if="formData.healthcareExecute.answer.includes('year')">({{formData.healthcareYear.answer}})</span>
                  <span class="ml-1" v-if="formData.healthcareExecute.answer.includes('otherReason')">■ </span>
                  <span class="ml-1" v-else>□ </span>
                  <span class="font-weight-bold">其他：</span>
                  <span class="ml-1 border-bottom-wording" v-if="formData.healthcareExecute.answer.includes('otherReason')">{{formData.healthcareOther.answer}}</span>
                  <span class="ml-1" v-else>______</span> )
                </p>
              </div>
              <div class="col-11 my-2">
                <div class="row">
                  <div class="col-6 border-left border-top">
                    <p class="font-weight-bold highlight-title">基本理學檢查:</p>
                    <p>視力 左(裸/矯): {{formData.unaidedVisualAcuityLeft.answer}} / {{formData.correctedVisualAcuityLeft.answer}}</p>
                    <p>右(裸/矯):  {{formData.unaidedVisualAcuityRight.answer}} / {{formData.correctedVisualAcuityRight.answer}} </p>
                    <p>身高: {{formData.height.answer}} cm； 體重: {{formData.weight.answer}} Kg</p>
                    <p>腰圍: {{formData.waist.answer}} cm</p>

                  </div>
                  <div class="col-6 border-left border-top border-right">
                    <p class="font-weight-bold highlight-title">尿液檢查:</p>
                    <p>空腹血糖: {{formData.bloodSugarBeforeMeals.answer}} mg/dL</p>
                    <p>血色素/血紅素: {{formData.hemoglobin.answer}} g/dl</p>
                    <p>白血球: {{formData.whiteBloodCells.answer}} </p>
                  </div>
                  <div class="col-6 border-left border-top">
                    <p class="font-weight-bold highlight-title">血液檢查:</p>
                    <p>尿蛋白: {{formData.urinaryProtein.answer}}</p>
                    <p>尿潛血: {{formData.urinaryOccultBlood.answer}}</p>
                    <p>尿糖: {{formData.glycosuria.answer}}</p>
                  </div>
                  <div class="col-6 border-left border-top border-right">
                    <p class="font-weight-bold highlight-title">肝功能/腎功能:</p>
                    <p>丙氨酸轉氨酶ALT: {{formData.alt.answer}} U/L </p>
                    <p>肌酸酐: {{formData.creatinineCr.answer}} mg/dl</p>
                  </div>
                  <div class="col-6 border-left border-top">
                    <p class="font-weight-bold highlight-title">血脂肪:</p>
                    <p>總膽固醇: {{formData.totalCholesterol.answer}} mg/dL</p>
                    <p>三酸甘油脂: {{formData.triglycerides.answer}} mg/dL</p>
                    <p>低密度膽固醇: {{formData.lowDensityCholesterol.answer}} mg/dL</p>
                    <p>高密度膽固醇: {{formData.highDensityCholesterol.answer}} mg/dL</p>
                  </div>
                  <div class="col-6 border-left border-top border-right">
                    <p class="font-weight-bold highlight-title">血壓:</p>
                    <p>體健檢時血壓: {{formData.systolicBloodPressureHealthCheck.answer}} / {{formData.diastolicBloodPressureHealthCheck.answer}} mmHg； 心跳: {{formData.pulseHealthCheck.answer}} 次/分</p>
                    <p>本次血壓: {{formData.systolicBloodPressure.answer}} / {{formData.diastolicBloodPressure.answer}} mmHg； 心跳: {{formData.pulse.answer}} 次/分</p>
                    <p>X光檢查：{{formData.xRayCheck.answer}}</p>
                  </div>
                  <div class="col-12 border-left border-top border-right">
                    <p class="font-weight-bold highlight-title">非法規項目:</p>
                    <p style="white-space: pre-line">{{formData.nonRegulatoryItem.answer}}</p>
                    <br v-if="formData.nonRegulatoryItem.answer.length===0" />
                  </div>
                  <div class="col-12 border-left border-top border-right border-bottom">
                    <p class="font-weight-bold highlight-title">風險等級:</p>
                    <p>
                      <span v-if="formData.riskLevel.answer==='1'">■ </span>
                      <span v-else>□ </span>一級
                      <span v-if="formData.riskLevel.answer==='2'">■ </span>
                      <span v-else>□ </span>二級
                      <span v-if="formData.riskLevel.answer==='3'">■ </span>
                      <span v-else>□ </span>三級
                      <span v-if="formData.riskLevel.answer==='4'">■ </span>
                      <span v-else>□ </span>四級
                    </p>
                  </div>
                </div>
              </div>

            </template>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0 justify-content-center">
            <div class="col-12">
              <p><span class="font-weight-bold mr-1">異常工作負荷促發疾病預防</span>
                <span v-if="formData.workloadExecute.answer==='yes'">■ </span>
                <span v-else>□ </span>
                本次執行
                <span v-if="formData.workloadExecute.answer==='no'">■ </span>
                <span v-else>□ </span>
                本次沒執行
              </p>
            </div>
            <template v-if="formData.workloadExecute.answer==='yes'">
              <div class="col-12">
                <p>需採取後續相關措施:
                  <span class="ml-1" v-if="formData.followUpMeasures.answer==='no'">■ </span>
                  <span class="ml-1" v-else>□ </span>
                  否
                  <span class="ml-1" v-if="formData.followUpMeasures.answer==='yes'">■ </span>
                  <span class="ml-1" v-else>□ </span>
                  是
                  <span class="ml-1" v-if="formData.followUpMeasures.answer==='suggestion'">■ </span>
                  <span class="ml-1" v-else>□ </span>
                  建議面談
                </p>
              </div>
              <div class="col-11 my-2">
                <div class="row">
                  <div class="col-3 border-top border-left">
                  </div>
                  <div class="col-4 border-top border-left">
                    <p>項目</p>
                  </div>
                  <div class="col-4 border-top border-left border-right">
                    <p>風險等級</p>
                  </div>
                  <div class="col-3 border-top border-left">
                    <p class="font-weight-bolder">心血管疾病風險</p>
                  </div>
                  <div class="col-4 border-top border-left">
                    <p>十年內腦、心血管疾病風險</p>
                  </div>
                  <div class="col-4 border-top border-left border-right">
                    <p>
                      <span v-if="formData.framinghamRiskLevel.answer==='0'">■ </span>
                      <span v-else>□ </span>低
                      <span v-if="formData.framinghamRiskLevel.answer==='1'">■ </span>
                      <span v-else>□ </span>中
                      <span v-if="formData.framinghamRiskLevel.answer==='2'">■ </span>
                      <span v-else>□ </span>高
                      <span v-if="formData.framinghamRiskLevel.answer==='3'">■ </span>
                      <span v-else>□ </span>極高
                    </p>
                  </div>
                  <div class="col-3 border-top border-left">
                    <p class="font-weight-bolder">工作過負荷風險</p>
                  </div>
                  <div class="col-4 border-top border-left">
                    <p>過勞量表_個人疲勞</p>
                  </div>
                  <div class="col-4 border-top border-left border-right">
                    <p>
                      <span v-if="formData.iScoreLevel.answer==='0'">■ </span>
                      <span v-else>□ </span>低
                      <span v-if="formData.iScoreLevel.answer==='1'">■ </span>
                      <span v-else>□ </span>中
                      <span v-if="formData.iScoreLevel.answer==='2'">■ </span>
                      <span v-else>□ </span>高
                    </p>
                  </div>
                  <div class="col-3 border-left">
                  </div>
                  <div class="col-4 border-top border-left">
                    <p>過勞量表_工作疲勞</p>
                  </div>
                  <div class="col-4 border-top border-left border-right">
                    <p>
                      <span v-if="formData.jScoreLevel.answer==='0'">■ </span>
                      <span v-else>□ </span>低
                      <span v-if="formData.jScoreLevel.answer==='1'">■ </span>
                      <span v-else>□ </span>中
                      <span v-if="formData.jScoreLevel.answer==='2'">■ </span>
                      <span v-else>□ </span>高
                    </p>
                  </div>
                  <div class="col-3 border-left">
                  </div>
                  <div class="col-4 border-top border-left">
                    <p>月平均延長工時</p>
                  </div>
                  <div class="col-4 border-top border-left border-right">
                    <p>
                      <span v-if="formData.overtimeHourLevel.answer==='0'">■ </span>
                      <span v-else>□ </span>低
                      <span v-if="formData.overtimeHourLevel.answer==='1'">■ </span>
                      <span v-else>□ </span>中
                      <span v-if="formData.overtimeHourLevel.answer==='2'">■ </span>
                      <span v-else>□ </span>高
                    </p>
                  </div>
                  <div class="col-3 border-left">
                  </div>
                  <div class="col-4 border-top border-left">
                    <p>工作型態</p>
                  </div>
                  <div class="col-4 border-top border-left border-right">
                    <p>
                      <span v-if="formData.jobTypeAssessmentLevel.answer==='0'">■ </span>
                      <span v-else>□ </span>低
                      <span v-if="formData.jobTypeAssessmentLevel.answer==='1'">■ </span>
                      <span v-else>□ </span>中
                      <span v-if="formData.jobTypeAssessmentLevel.answer==='2'">■ </span>
                      <span v-else>□ </span>高
                    </p>
                  </div>
                  <div class="col-3 border-top border-left border-bottom">
                    <p class="font-weight-bolder">綜合評估</p>
                  </div>
                  <div class="col-4 border-top border-left border-bottom">
                    <p>職業促發腦、心血管疾病風險</p>
                  </div>
                  <div class="col-4 border-top border-left border-right border-bottom">
                    <p>
                      <span v-if="formData.cardiovascularDiseaseRiskLevel.answer==='0'">■ </span>
                      <span v-else>□ </span>０
                      <span v-if="formData.cardiovascularDiseaseRiskLevel.answer==='1'">■ </span>
                      <span v-else>□ </span>１
                      <span v-if="formData.cardiovascularDiseaseRiskLevel.answer==='2'">■ </span>
                      <span v-else>□ </span>２
                      <span v-if="formData.cardiovascularDiseaseRiskLevel.answer==='3'">■ </span>
                      <span v-else>□ </span>３
                      <span v-if="formData.cardiovascularDiseaseRiskLevel.answer==='4'">■ </span>
                      <span v-else>□ </span>４
                    </p>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0 justify-content-center">
            <div class="col-12">
              <p><span class="font-weight-bold mr-1">人因性危害預防</span>
                <span v-if="formData.ergonomicHazardsExecute.answer==='yes'">■ </span>
                <span v-else>□ </span>
                本次執行
                <span v-if="formData.ergonomicHazardsExecute.answer==='no'">■ </span>
                <span v-else>□ </span>
                本次沒執行
              </p>
            </div>
            <template v-if="formData.ergonomicHazardsExecute.answer==='yes'">
              <div class="col-11 my-2">
                <div class="row">
                  <div class="col-3 border-top border-left">
                    <p>風險等級</p>
                  </div>
                  <div class="col-9 border-top border-left border-right">
                    <p>
                      <span class="ml-1" v-if="formData.ergonomicHazardsRiskLevel.answer==='E1'">■ </span>
                      <span class="ml-1" v-else>□ </span>
                      無危害
                      <span class="ml-1" v-if="formData.ergonomicHazardsRiskLevel.answer==='E2'">■ </span>
                      <span class="ml-1" v-else>□ </span>
                      疑似有危害
                      <span class="ml-1" v-if="formData.ergonomicHazardsRiskLevel.answer==='E3'">■ </span>
                      <span class="ml-1" v-else>□ </span>
                      有危害
                      <span class="ml-1" v-if="formData.ergonomicHazardsRiskLevel.answer==='E3'">{{formData.ergonomicHazardsRiskNote.answer}}</span>
                      <span class="ml-1" v-else>_________</span>
                    </p>
                  </div>
                  <div class="col-3 border-top border-left">
                    <p>最高症狀部位及分數</p>
                  </div>
                  <div class="col-9 border-top border-left border-right">
                    <p style="white-space: pre-line">{{formData.ergonomicHazardsHighestSymptomSite.answer}}</p>
                  </div>
                  <div class="col-3 border-top border-left">
                    <p>疼痛部位</p>
                  </div>
                  <div class="col-9 border-top border-left border-right">
                    <p style="white-space: pre-line">{{formData.ergonomicHazardsSymptomSiteList.answer}}</p>
                  </div>
                  <div class="col-3 border-top border-left border-bottom">
                    <p>原因</p>
                  </div>
                  <div class="col-9 border-top border-left border-right border-bottom">
                    <p style="white-space: pre-line">{{formData.ergonomicHazardsRiskReason.answer}}</p>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-12">
              <p><span class="font-weight-bolder mr-1">母性健康保護</span>
                <span v-if="formData.maternalHealthProtectionExecute.answer==='yes'">■ </span>
                <span v-else>□ </span>
                本次執行
                <span v-if="formData.maternalHealthProtectionExecute.answer==='no'">■ </span>
                <span v-else>□ </span>
                本次沒執行
              </p>
            </div>
            <template v-if="formData.maternalHealthProtectionExecute.answer==='yes'">
              <div class="col-12">
                <p>
                  <span class="ml-1" v-if="formData.pregnancyType.answer==='P1'">■ </span>
                  <span class="ml-1" v-else>□ </span>
                  孕期中
                </p>
                <p>
                  <span class="ml-1" v-if="formData.pregnancyType.answer==='P2'">■ </span>
                  <span class="ml-1" v-else>□ </span>
                  產後
                </p>
                <p>
                  管理級別：
                  <span v-if="formData.maternalHealthProtectionLevel.answer==='0'">■ </span>
                  <span v-else>□ </span>無
                  <span v-if="formData.maternalHealthProtectionLevel.answer==='1'">■ </span>
                  <span v-else>□ </span>一級
                  <span v-if="formData.maternalHealthProtectionLevel.answer==='2'">■ </span>
                  <span v-else>□ </span>二級
                  <span v-if="formData.maternalHealthProtectionLevel.answer==='3'">■ </span>
                  <span v-else>□ </span>三級
                </p>
                <p>
                  管理措施：
                  <span style="white-space: pre-line">{{formData.maternalHealthProtectionNote.answer}}</span>
                </p>

              </div>
            </template>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-12">
              <p><span class="font-weight-bolder mr-1">執行職務不法侵害預防</span>
                <span v-if="formData.preventionIllegalInfringementDutyExecute.answer==='yes'">■ </span>
                <span v-else>□ </span>
                本次執行
                <span v-if="formData.preventionIllegalInfringementDutyExecute.answer==='no'">■ </span>
                <span v-else>□ </span>
                本次沒執行
              </p>
            </div>
            <template v-if="formData.preventionIllegalInfringementDutyExecute.answer==='yes'">
              <div class="col-12">
                <p>
                  管理措施：
                  <span style="white-space: pre-line">{{formData.preventionIllegalInfringementDutyNote.answer}}</span>
                </p>

              </div>
            </template>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-12">
              <p><span class="font-weight-bolder mr-1">45歲以上勞工健康管理</span>
                <span v-if="formData.laborHealthManagementExecute.answer==='yes'">■ </span>
                <span v-else>□ </span>
                本次執行
                <span v-if="formData.laborHealthManagementExecute.answer==='no'">■ </span>
                <span v-else>□ </span>
                本次沒執行
              </p>
            </div>
            <template v-if="formData.laborHealthManagementExecute.answer==='yes'">
              <div class="col-12">
                <p>
                  管理措施：
                  <span style="white-space: pre-line">{{formData.laborHealthManagementNote.answer}}</span>
                </p>
              </div>
            </template>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-12">
              <p><span class="font-weight-bolder mr-1">復工評估與管理</span>
                <span v-if="formData.returnToWorkAssessmentExecute.answer==='yes'">■ </span>
                <span v-else>□ </span>
                本次執行
                <span v-if="formData.returnToWorkAssessmentExecute.answer==='no'">■ </span>
                <span v-else>□ </span>
                本次沒執行
              </p>
            </div>
            <template v-if="formData.returnToWorkAssessmentExecute.answer==='yes'">
              <div class="col-12">
                <p>
                  管理措施：
                  <span style="white-space: pre-line">{{formData.returnToWorkAssessmentNote.answer}}</span>
                </p>
              </div>
            </template>
          </div>
        </div>
        <div v-if="formData.hasOtherNote.answer" class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-12">
              <p>
                <span>■ </span>
                <span class="font-weight-bolder">其他:</span>
                <template v-if="formData.hasOtherNote.answer">
                  <span style="white-space: pre-line">{{formData.otherNote.answer}}</span>
                </template>
              </p>
            </div>

          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-3">
              <p>採行措施與建議事項</p>
            </div>
            <div class="col-8 border-left">
              <p>
                <span v-if="formData.healthGuidance.answer!==''">■ </span>
                <span v-else>□ </span>
                健康指導:
                <span v-if="formData.healthGuidance.answer!==''" style="white-space: pre-line">{{formData.healthGuidance.answer}}</span>
                <span v-else>______</span>
              </p>
              <p>
                <span v-if="formData.workPrecautionseNote.answer!==''">■ </span>
                <span v-else>□ </span>
                工作注意事項:
                <span v-if="formData.workPrecautionseNote.answer!==''" style="white-space: pre-line">{{formData.workPrecautionseNote.answer}}</span>
                <span v-else>______</span>
              </p>
              <p>
                <span v-if="formData.track.answer==='track'">■ </span>
                <span v-else>□ </span>
                是, 後續追蹤
                <span v-if="formData.track.answer==='track'">{{formData.trackDate.answer}}</span>
                <span v-else>_______</span>
                <span class="ml-1" v-if="formData.track.answer==='close'">■ </span>
                <span class="ml-1" v-else>□ </span>
                結案
              </p>
              <p>
                <span v-if="formData.otherMeasuresRecommendation.answer!==''">■ </span>
                <span v-else>□ </span>
                其他:
                <span v-if="formData.otherMeasuresRecommendation.answer!==''" style="white-space: pre-line">{{formData.otherMeasuresRecommendation.answer}}</span>
                <span v-else>______</span>
              </p>
            </div>
          </div>
        </div>
        <div class="outline-bottom workers-field">
          <div class="row p-0">
            <div class="col-12">
              <p class="m-1">本人知悉並同意，本工作場所雇主依「職業安全衛生法」「勞工健康保護規則」」等相關規定之立法意主旨，辦理勞工健康管理，為選配工與職業傷病預防。對於可能之肌肉骨骼傷害、異常工作負荷促發疾病、工作場所母性健康保護及執行職務因他人行為遭受身體或精神不法侵害預防之危害辨識、評估、適性工作安排等作為之義務，其規定之目的係為保障工作者安全及健康，有關應採行之安全衛生措施，公告各項預防計畫及相關管理辦法，並委託特約臨場健康服務醫事人員依各該計畫書及管理辦法所附調查表採取健康管理措施，與收集相關個人資料以利執行、紀錄等，及依據所定期限及項目之檢查結果，得依法進行紀錄之保存、處理及利用，不得逾越前開特定目的範圍，且須依相關規則規定保障勞工隱私權，以符個資法之規定。
                本人瞭解並簽名同意符合個人資料保護法及相關法規之要求，具有書面同意蒐集、處理及利用立書人的個人資料之效果。
              </p>
            </div>
            <div class="col-12">
              <p class="text-right w-100 pr-2">
                員工(簽章/日期)：
                <img v-if="formData.laborSigne.answer" style="width: 200px" :src="formData.laborSigne.answer" alt="img" />
                <span v-if="formData.laborSigneDate.answer">{{formData.laborSigneDate.answer}}</span>
                <span v-else>___________________</span>

              </p>
              <p class="text-right w-100 pr-2">
                協助醫護人員(簽章/日期):
                <img v-if="formData.medicalStaffSigne.answer" style="width: 200px" :src="formData.medicalStaffSigne.answer" alt="img" />
                <span v-if="formData.medicalStaffSigneDate.answer">{{formData.medicalStaffSigneDate.answer}}</span>
                <span v-else>___________________</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import occupationalPatientSchemaService from '@/services/occupational.patient.schema';
import moment from 'moment';

export default {
  name: 'PremiumOccupationalConsultNotePrint',
  props: {
    selectedPatient: {
      type: Object,
      default: () => ({}),
    },
    selectedConsultNote: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    formData() {
      return this.selectedConsultNote.mainForm.formData;
    },
    getCreateDate() {
      const { createdAt } = this.selectedConsultNote.invoice;
      const createDate = moment(createdAt);

      return createDate.format('YYYY 年 MM 月 DD 日');
    },
    getGenderWording() {
      const gender = this.selectedPatient.gender.toLowerCase();
      let rtn = '';
      if (gender === 'f') {
        rtn = this.$t('serviceRecordSheet.female');
      } else if (gender === 'm') {
        rtn = this.$t('serviceRecordSheet.male');
      }

      return rtn;
    },
    getSpecialHazardousWorkWording1() {
      const data = occupationalPatientSchemaService.normalTemplateDataOption
        .specialHazardousWork.find(item => item.value === this.formData.specialHazardousWork1.answer);
      return data.text;
    },
    getSpecialHazardousWorkWording2() {
      const data = occupationalPatientSchemaService.normalTemplateDataOption
        .specialHazardousWork.find(item => item.value === this.formData.specialHazardousWork2.answer);
      return data.text;
    },
    getSpecialHazardousWorkWording3() {
      const data = occupationalPatientSchemaService.normalTemplateDataOption
        .specialHazardousWork.find(item => item.value === this.formData.specialHazardousWork3.answer);
      return data.text;
    },
    getSpecialHazardousWorkWording4() {
      const data = occupationalPatientSchemaService.normalTemplateDataOption
        .specialHazardousWork.find(item => item.value === this.formData.specialHazardousWork4.answer);
      return data.text;
    },
    getSpecialHazardousWorkWording5() {
      const data = occupationalPatientSchemaService.normalTemplateDataOption
        .specialHazardousWork.find(item => item.value === this.formData.specialHazardousWork5.answer);
      return data.text;
    },
  },
  data() {
    return {
      templateId: '',
    };
  },
  mounted() {
    setTimeout(() => {
      window.print();
    }, 2000);
  },
};
</script>

<style lang="scss" scoped>
.content-item {
  padding-left: 15pt;
  padding-right: 15pt;
}
p {
  margin-bottom: 0;
}
.outline-border {
  border-top: 1.5pt solid black;
  border-right: 1.5pt solid black;
  border-left: 1.5pt solid black;
  p {
    padding-left: 10pt;
  }
}
.outline-bottom {
  border-bottom: 1.5pt solid black;
}
.outline-left {
  border-left: 1.5pt solid black;
}

.workers-field {
  .title {
    width: 120px;
    height: 50px;
    flex: 0 0 120pt !important;
    max-width: 120pt !important;
  }
  .content {
    border-left: 0.5pt solid black;
    margin-bottom: 2pt;
  }
  .category-item {
    margin-left: 10pt;
  }
}
.signatures {
  img {
    width: 120px;
    margin-bottom: 5pt;
  }
}

.number-field {
  border-bottom: 0.5pt solid black;
  min-width: 35pt;
  text-align: center;
  display: inline-block;
}

.line-break {
  white-space: pre-line;
}

.border-top {
  border-top: black 1.5pt solid !important;
}

.border-right {
  border-right: black 1.5pt solid !important;
}

.border-left {
  border-left: black 1.5pt solid !important;
}

.border-bottom {
  border-bottom: black 1.5pt solid !important;
}

.border-bottom-wording {
  border-bottom: black 1pt solid !important;
}

.title {
  width: 120px;
  flex: 0 0 120pt !important;
  max-width: 120pt !important;
}
.operator-content {
  flex: 0 0 calc(100% - 16.6666666667% - 120pt);
  max-width: calc(100% - 16.6666666667% - 120pt);
}
.center-title {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.h-work-title {
  flex: 0 0 150pt;
  max-width: 150pt;
}
.h-work-option {
  flex: 0 0 calc(100% - 25% - 150pt);
  max-width: calc(100% - 25% - 150pt);
}
.highlight-title {
  margin-top: 2pt;
  background-color: #dfdfdf;
  width: fit-content;
  padding: 0 !important;
  margin-left: 10pt;
}

@media print {
  .title {
    width: 120px;
    flex: 0 0 120pt !important;
    max-width: 120pt !important;
  }
  .content-item {
    page-break-after: always;
    padding-left: 15pt;
    padding-right: 15pt;
  }
  p {
    margin-bottom: 0;
  }
  h3 {
    font-size: 16pt;
  }
  .service-date {
    font-size: 10pt;
  }
  .outline-border {
    border-top: 0.5pt solid black;
    border-right: 0.5pt solid black;
    border-left: 0.5pt solid black;
    p {
      padding-left: 10pt;
    }
  }
  .outline-bottom {
    border-bottom: 0.5pt solid black;
  }
  .outline-left {
    border-left: 0.5pt solid black;
  }

  .workers-field {
    .title {
      width: 120px;
      height: 50px;
      flex: 0 0 120pt !important;
      max-width: 120pt !important;
    }
    .content {
      border-left: 0.5pt solid black;
      margin-bottom: 2pt;
    }
    .category-item {
      margin-left: 10pt;
    }
  }
  .signatures {
    page-break-inside: avoid;
    img {
      width: 120px;
      margin-top: 5pt;
      margin-bottom: 5pt;
    }
  }

  .border-top {
    border-top: black 1pt solid !important;
  }

  .border-right {
    border-right: black 1pt solid !important;
  }

  .border-left {
    border-left: black 1pt solid !important;
  }

  .border-bottom {
    border-bottom: black 1pt solid !important;
  }

  .border-bottom-wording {
    border-bottom: black 1pt solid !important;
  }

  .operator-content {
    flex: 0 0 calc(100% - 16.6666666667% - 120pt);
    max-width: calc(100% - 16.6666666667% - 120pt);
  }
  .center-title {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .h-work-title {
    flex: 0 0 150pt;
    max-width: 150pt;
  }
  .h-work-option {
    flex: 0 0 calc(100% - 25% - 150pt);
    max-width: calc(100% - 25% - 150pt);
  }
  .highlight-title {
    margin-top: 2pt;
    background-color: #dfdfdf;
    width: fit-content;
    padding: 0 !important;
    margin-left: 10pt;
  }

}
</style>
